import { render, staticRenderFns } from "./Application.vue?vue&type=template&id=04cb5e5c&scoped=true"
import script from "./Application.vue?vue&type=script&lang=js"
export * from "./Application.vue?vue&type=script&lang=js"
import style0 from "./Application.vue?vue&type=style&index=0&id=04cb5e5c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04cb5e5c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04cb5e5c')) {
      api.createRecord('04cb5e5c', component.options)
    } else {
      api.reload('04cb5e5c', component.options)
    }
    module.hot.accept("./Application.vue?vue&type=template&id=04cb5e5c&scoped=true", function () {
      api.rerender('04cb5e5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Application.vue"
export default component.exports